import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Container, CardDeck, Card } from 'react-bootstrap'
import { graphql } from 'gatsby'
import { request } from 'graphql-request'

import ObservabilityImage from '../images/home/observability-right-block.svg'
import MetricImage from '../images/home/metric-block.svg'
// import Lya from '../images/home/lya.png'
import Patreon from '../images/home/patreon.png'
import Truebill from '../images/home/truebill.png'
import Thumbtack from '../images/home/thumbtack.png'
import Faire from '../images/home/faire.png'
import Dutchie from '../images/home/dutchie.png'
import DataCataloBg from '../images/home/data-catalog-bg.png'
import DataCatalogImage from '../images/home/data-catalog-block.svg'
import Points from '../images/home/points.svg'
import PointsV2Image from '../images/home/points-v2.svg'
import PointsV3Image from '../images/home/points-v3.svg'
import DataDiffImage from '../images/home/data-diff-block.svg'
import GitBranchImage from '../images/home/git-branch.svg'
import CloudImage from '../images/home/cloud.svg'
import ArrowsImage from '../images/home/arrows.svg'
import CheckMarkImage from '../images/home/check-mark.svg'
import IntegrationsImage from '../images/home/integrations-block.svg'
import IntegrationsMobile from '../images/home/integrations-mobile.png'
import ArrowsIconImage from '../images/home/arrows-icon.svg'
import ManIconImage from '../images/data-diff/man-icon.svg'
import DollarIconImage from '../images/home/dollar-icon.svg'
import MobilePointsImage from '../images/home/mobilePoints.svg'
// import catalog from '../video/catalog.mp4'

import { Layout, Testimonials, ActNow, ButtonAnalytics } from '../components/common'
import { MetaData } from '../components/common/meta'
import { graphCMSUrl } from '../utils/siteConfig'

/**
* Main index page (home page)
*
* Loads all posts from Ghost and uses pagination to navigate through them.
* The number of posts that should appear per page can be setup
* in /utils/siteConfig.js under `postsPerPage`.
*
*/
const Index = ({ data, location }) => {
    const [videoLoad, setVideoLoad] = useState(false)
    const [testimonialList, setTestimonialList] = useState([])

    useEffect(() => {
        const fetchTestimonials = async () => {
            const { testimonials } = await request(
                graphCMSUrl,
                `
                {
                    testimonials(stage: PUBLISHED) {
                        id
                        personName
                        personRole
                        blurb
                        companyLogo {
                            url
                        }
                        personAvatar {
                            fileName
                            url
                        }
                    }
                  }
                `
            )
            setTestimonialList(testimonials)
        }

        fetchTestimonials()
    }, [])

    /*const handleOnload = () => {
        setVideoLoad(true)
    }*/

    return (
        <>
            <MetaData location={location} data={data} />
            <Layout footerClass="large">
                <section className="observability">
                    <Container>
                        <Row xs={1} md={2} style={{ alignItems: 'center' }} className="observability-data">
                            <Col>
                                <span className="sub-title">DATA OBSERVABILITY PLATFORM</span>
                                <h1>
                                    {/*{site.title}*/}
                                    Monitoring for your data
                                </h1>
                                <p className="general-content">
                                    Datafold gives you confidence in your data quality through diffs, profiling, and anomaly detection — all integrated into your existing infrastructure & CI
                                </p>
                                <div className="button-group">
                                    <ButtonAnalytics
                                        schedule="true"
                                        variant="outline-primary"
                                        size="lg"
                                        style={{ marginRight: '16px' }}
                                        actionname="Schedule Demo"
                                    >
                                            Schedule Demo
                                    </ButtonAnalytics>
                                    <ButtonAnalytics
                                        href="https://app.datafold.com/org-signup"
                                        target="_blank"
                                        variant="primary"
                                        size="lg"
                                        action_name="Start for Free"
                                    >
                                        Start for Free
                                    </ButtonAnalytics>
                                </div>
                            </Col>
                            <Col className="image-block" style={{ textAlign: 'right' }}>
                                <ObservabilityImage style={{ width: '100%', maxWidth: '540px', height: 'auto' }}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <h4>Used by the most data-driven companies</h4>
                                <div className="partners">
                                    {/*<img src={Lya} alt="Lya"/>*/}
                                    <img src={Thumbtack} alt="Thumbtack"/>
                                    <img src={Patreon} alt="Patreon"/>
                                    <img src={Truebill} alt="Truebill"/>
                                    <br/>
                                    <img src={Faire} alt="Faire"/>
                                    <img src={Dutchie} alt="Dutchie"/>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="metric">
                    <Container>
                        <Row style={{ textAlign: 'center' }}>
                            <Col>
                                <span className="sub-title">METRIC MONITORING</span>
                                <h2>
                                    Know when things go wrong
                                </h2>
                                <p
                                    className="general-content"
                                    style={{ maxWidth: '527px' }}
                                >
                                    Datafold learns the normal behavior of your data and notifies you of anomalies through your favorite channels
                                </p>
                                <ButtonAnalytics href="/data-monitoring" variant="primary" size="lg" action_name="Learn more(Metric monitoring)">
                                        Learn more
                                </ButtonAnalytics>
                                <div className="metric-image-block">
                                    <MetricImage/>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="data-catalog" id="data-anchor">
                    <Container>
                        <Row xs={1} md={2} style={{ alignItems: 'center' }} className="data-catalog-row">
                            <Col>
                                <div className="left-block">
                                    <DataCatalogImage style={{ display: (videoLoad ? 'none' : '') }} />
                                    {/*<video style={{ display: (videoLoad ? 'block' : 'none') }} autoPlay loop muted onLoadedData={handleOnload}>
                                        <source src={catalog} type="video/mp4"></source>
                                    </video>*/}
                                </div>
                            </Col>
                            <Col className="right-block row" style={{ textAlign: 'left' }}>
                                <img className="right-block-bg" src={DataCataloBg} alt="right block"/>
                                <div className="col-md-8 offset-md-2">
                                    <span className="sub-title">Data Catalog</span>
                                    <h2>
                                        Know your data
                                    </h2>
                                    <p className="general-content">
                                        Easily find relevant datasets, fields and explore distributions
                                    </p>
                                </div>
                                <Points className="desktop-points"/>
                                <MobilePointsImage className="mobile-points"/>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="data-diff">
                    <div className="container-fluid-right">
                        <Row style={{ alignItems: 'center' }}>
                            <Col md={4}>
                                <span className="sub-title">Data Diff</span>
                                <h2>
                                    Automate data QA
                                </h2>
                                <p className="general-content">
                                    Improve reliability of your ETL process with automatic regression testing for code changes and data transfers
                                </p>
                                <ButtonAnalytics href="/data-diff" variant="primary" size="lg" action_name="Learn more(Data diff)">
                                    Learn more
                                </ButtonAnalytics>
                            </Col>
                            <Col className="to-right-side">
                                <DataDiffImage/>
                            </Col>
                        </Row>

                    </div>
                </section>
                <section className="data-monitoring">
                    <Container>
                        <Row style={{ textAlign: 'center' }}>
                            <Col>
                                <span className="sub-title">Data Monitoring As a Service</span>
                                <h2>
                                    Don’t let bad data slow you down
                                </h2>
                                <p className="general-content">
                                    Datafold automates data quality monitoring so you can focus on analyzing & using the data
                                </p>
                                <CardDeck className="card-block col-xl-12 col-md-12">
                                    <Card>
                                        <GitBranchImage/>
                                        <Card.Body>
                                            <Card.Title>Fits your workflow</Card.Title>
                                            <Card.Text as="div">
                                                <p><CheckMarkImage/><span>Automate manual tasks</span></p>
                                                <p><CheckMarkImage/><span>Implement best practices</span></p>
                                                <p><CheckMarkImage/><span>Integrate with your tools</span></p>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                    <Card>
                                        <CloudImage/>
                                        <Card.Body>
                                            <Card.Title>Enterprise ready</Card.Title>
                                            <Card.Text as="div">
                                                <p><CheckMarkImage/><span>{'Deploys on-prem in < 30 min'}</span></p>
                                                <p><CheckMarkImage/><span>Integrates with SSO providers </span></p>
                                                <p><CheckMarkImage/><span>Security & Privacy compliant</span></p>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                    <Card>
                                        <ArrowsImage/>
                                        <Card.Body>
                                            <Card.Title>Immediate Impact</Card.Title>
                                            <Card.Text as="div">
                                                <p><CheckMarkImage/><span>Improve team productivity</span></p>
                                                <p><CheckMarkImage/><span>Minimize risk of data incidents</span></p>
                                                <p><CheckMarkImage/><span>Unlock more value in your data</span></p>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </CardDeck>
                            </Col>
                        </Row>
                    </Container>
                    <PointsV2Image className="left-points"/>
                </section>
                {(testimonialList && testimonialList.length > 0) && (
                    <section className="happy-customers">
                        <Container>
                            <Row style={{ textAlign: 'center' }}>
                                <Col>
                                    <span className="sub-title">HAPPY USERS</span>
                                    <h2>
                                    Loved by data professionals
                                    </h2>
                                    <div className="card-slider col-xl-9 col-md-10">
                                        <Testimonials testimonials={testimonialList} />
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                )}
                <section className="integrations">
                    <Container>
                        <Row style={{ textAlign: 'center' }}>
                            <Col>
                                <span className="sub-title">Integrations</span>
                                <h2>
                                    Missing puzzle piece in your data stack
                                </h2>
                                <p
                                    className="general-content"
                                    style={{ maxWidth: '527px' }}
                                >
                                    Datafold seamlessly plugs in all major SQL data warehouses and ETL tools
                                </p>
                                <div>
                                    <IntegrationsImage className="integrations-image"/>
                                    <img src={IntegrationsMobile} alt="integrations" className="integrations-image-mobile" />
                                </div>
                            </Col>
                        </Row>
                        <PointsV3Image className="right-points"/>
                    </Container>
                </section>
                <section className="immediate-business-impact">
                    <Container>
                        <Row style={{ textAlign: 'center' }}>
                            <Col>
                                <span className="sub-title">Immediate business impact</span>
                                <h2>
                                    Improved data observability benefits everyone
                                </h2>
                                <CardDeck className="card-block col-xl-11 col-md-12">
                                    <Card>
                                        <ArrowsIconImage/>
                                        <Card.Body>
                                            <Card.Title>Data Developer</Card.Title>
                                            <Card.Text as="div">
                                                <p><CheckMarkImage/><span>Deploy with confidence</span></p>
                                                <p><CheckMarkImage/><span>Eliminate toil work</span></p>
                                                <p><CheckMarkImage/><span>Focus on creative tasks</span></p>
                                                <p><CheckMarkImage/><span>Increase productivity</span></p>
                                            </Card.Text>
                                        </Card.Body>
                                        <Card.Footer>
                                            <ButtonAnalytics
                                                href="https://app.datafold.com/org-signup"
                                                target="_blank"
                                                variant="primary"
                                                size="lg"
                                                action_name="Get Started for free (Immediate business impact)"
                                            >
                                                Get Started for free
                                            </ButtonAnalytics>
                                        </Card.Footer>
                                    </Card>
                                    <Card>
                                        <ManIconImage/>
                                        <Card.Body>
                                            <Card.Title>Data Team Manager</Card.Title>
                                            <Card.Text as="div">
                                                <p><CheckMarkImage/><span>Prevent data incidents</span></p>
                                                <p><CheckMarkImage/><span>Establish data quality culture</span></p>
                                                <p><CheckMarkImage/><span>Increase team velocity</span></p>
                                                <p><CheckMarkImage/><span>Improve stakeholder trust</span></p>
                                            </Card.Text>

                                        </Card.Body>
                                        <Card.Footer>
                                            <ButtonAnalytics href="/calculator" variant="primary" size="lg" action_name="Estimate Impact">
                                                    Estimate Impact
                                            </ButtonAnalytics>
                                        </Card.Footer>
                                    </Card>
                                    <Card>
                                        <DollarIconImage/>
                                        <Card.Body>
                                            <Card.Title>Business User</Card.Title>
                                            <Card.Text as="div">
                                                <p><CheckMarkImage/><span>Be confident in data</span></p>
                                                <p><CheckMarkImage/><span>Minimize business risk</span></p>
                                                <p><CheckMarkImage/><span>Get data faster</span></p>
                                                <p style={{ opacity: 0 }}>none</p>
                                            </Card.Text>
                                        </Card.Body>
                                        <Card.Footer>
                                            <ButtonAnalytics
                                                href="https://app.datafold.com/login?next=https%3A%2F%2Fapp.datafold.com%2F"
                                                variant="primary"
                                                target="_blank"
                                                size="lg"
                                                action_name="See a live Example"
                                            >
                                            See a live Example
                                            </ButtonAnalytics>
                                        </Card.Footer>
                                    </Card>
                                </CardDeck>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <ActNow/>
            </Layout>
        </>
    )
}

Index.propTypes = {
    data: PropTypes.shape({
        allGhostSettings: PropTypes.object.isRequired,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    pageContext: PropTypes.object,
}

export default Index

// This page query loads all posts sorted descending by published date
// The `limit` and `skip` values are used for pagination
export const pageQuery = graphql`
  query GhostPostQuery {
    allGhostSettings {
        edges {
          node {
            description
            title
          }
        }
      }
  }
`
